import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import Thanks from '../components/Thanks'

function ThanksContainer({ location }) {
  return <Thanks search={qs.parse(location.search)} />
}

ThanksContainer.propTypes = {
  location: PropTypes.object,
}

export default Title(Analytics(ThanksContainer), 'Cadastrado com sucesso na Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/Thanks.js